import { handleError } from "core/utils/HandleError"
import { handleResponse } from "core/utils/HandleResponse"
import { AuthHttpClient } from "core/utils/HttpClient"

export function getTournaments(params: any) {
  return AuthHttpClient
    .get('/admin/tournament', { params })
    .then(handleResponse)
    .catch(handleError)
}

export function getTournamentById(tournamentId: string) {
  return AuthHttpClient
    .get(`/admin/tournament/${tournamentId}`)
    .then(handleResponse)
    .catch(handleError)
}

export function addTournament(tournament: any) {
  return AuthHttpClient
    .post('/admin/tournament', tournament)
    .then(handleResponse)
    .catch(handleError)
}

export function createPlayoff(
  tournamentPayload:
    | string
    | {
        tournamentId: string;
        eligibleParticipants?: "all" | "checkedIn";
        playoffsConfig?: Record<string, any>[];
      }
) {
  const payload =
    typeof tournamentPayload === "string"
      ? { tournamentId: tournamentPayload }
      : tournamentPayload;

  return AuthHttpClient
    .post(`/admin/tournament/playoff`, payload)
    .then(handleResponse)
    .catch(handleError)
}

export function updateTournament(data: any) {
  return AuthHttpClient
    .put('/admin/tournament', data)
    .then(handleResponse)
    .catch(handleError)
}

export function deleteTournament(tournamentId: string) {
  return AuthHttpClient
    .delete(`/admin/tournament/${tournamentId}`)
    .then(handleResponse)
    .catch(handleError)
}

export function addStreamLink(tournamentData: any) {
  return AuthHttpClient
    .patch(`/admin/tournament/stream`, tournamentData)
    .then(handleResponse)
    .catch(handleError)
}

export function createTournamentPost(tournamentData: any) {
  return AuthHttpClient
    .patch(`/admin/tournament/publish`, tournamentData)
    .then(handleResponse)
    .catch(handleError)
}

export function pinTournament(pinData: any) {
  return AuthHttpClient
    .patch(`/admin/pin/tournament`, pinData)
    .then(handleResponse)
    .catch(handleError)
}

export function getPinnedTournaments(params: any) {
  return AuthHttpClient
    .get(`/admin/pin/tournament`, { params })
    .then(handleResponse)
    .catch(handleError)
}


// Temp Service

export function getProvisionalTournaments(params: any) {
  return AuthHttpClient
    .get('/admin/provisional/tournament', { params })
    .then(handleResponse)
    .catch(handleError)
}

export function getProvisionalTournamentById(tournamentId: string) {
  return AuthHttpClient
    .get(`/admin/provisional/tournament/${tournamentId}`)
    .then(handleResponse)
    .catch(handleError)
}

export function updateProvisionalTournamentStatus(statusData: any) {
  return AuthHttpClient
    .patch('/admin/provisional/tournament', statusData)
    .then(handleResponse)
    .catch(handleError)
}

// AI Tournament API

export function getGameDataForAITournament() {
  return AuthHttpClient
    .get('/admin/tournament/game/data')
    .then(handleResponse)
    .catch(handleError)
}

export function createAITournament(formData: any) {
  return AuthHttpClient
    .post('/admin/tournament/ai/create', formData)
    .then(handleResponse)
    .catch(handleError)
}

export function exportExcelTournament(id: string) {
  return AuthHttpClient
    .get(`/admin/tournament/customfield/export/${id}`)
    .then(handleResponse)
    .catch(handleError)
}

